var _path, _path2, _path3, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRockyFinanceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "10 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 30C16.75 19.3687 25.3687 10.75 36 10.75C46.63 10.75 55.25 19.3687 55.25 30C55.25 40.6313 46.6313 49.25 36 49.25C25.3687 49.25 16.75 40.6313 16.75 30Z",
    fill: "url(#paint0_linear_icon)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0252 32.1886C41.3781 32.1886 40.8535 32.7132 40.8535 33.3603V34.8535H39.3604C38.7132 34.8535 38.1887 35.3781 38.1887 36.0252C38.1887 36.6723 38.7132 37.1969 39.3604 37.1969H40.8535V38.69C40.8535 39.3372 41.3781 39.8617 42.0252 39.8617C42.6723 39.8617 43.1969 39.3372 43.1969 38.69V37.1969H44.6901C45.3372 37.1969 45.8618 36.6723 45.8618 36.0252C45.8618 35.3781 45.3372 34.8535 44.6901 34.8535H43.1969V33.3603C43.1969 32.7132 42.6723 32.1886 42.0252 32.1886Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9928 20.1562C29.3457 20.1562 28.8211 20.6808 28.8211 21.3279V22.8211H27.3279C26.6808 22.8211 26.1562 23.3457 26.1562 23.9928C26.1562 24.6399 26.6808 25.1645 27.3279 25.1645H28.8211V26.6577C28.8211 27.3048 29.3457 27.8294 29.9928 27.8294C30.6399 27.8294 31.1645 27.3048 31.1645 26.6577V25.1645H32.6577C33.3048 25.1645 33.8294 24.6399 33.8294 23.9928C33.8294 23.3457 33.3048 22.8211 32.6577 22.8211H31.1645V21.3279C31.1645 20.6808 30.6399 20.1562 29.9928 20.1562Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.8529,
    y: 35.9579,
    width: 19.9477,
    height: 3.23164,
    rx: 1.61582,
    transform: "rotate(-45 27.8529 35.9579)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_icon",
    x1: 36,
    y1: 69.4569,
    x2: 36,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRockyFinanceLogo);
export default __webpack_public_path__ + "static/media/rockyFinanceLogo.cc0f7a4f340d1267b6e0ad18006a5902.svg";
export { ForwardRef as ReactComponent };